// KEEP THIS INFO UP TO DATE WITH ok-styles REPO -> /src/styles/_colors.scss
module.exports = {
    CYAN_ACCENT: '#31C3DF',
    WEALTH_MIX: '#A6A6A6',
    YELLOW_BASE: '#FBB800',
    COLOR_CATEGORY_DEFAULT: '#31C3DF',
    GRAY_BACKGROUND: '#E3E9E9'
};